import {
  useOrganization,
  useOrganizationUsersSort,
  useUpdateOrganizationUsersSort,
} from '../../../../../../features/organization';
import { Sort } from '../../../../sort';
import { IUsersSortProps } from './types';

export const UsersSort = ({ by }: IUsersSortProps) => {
  const updateSort = useUpdateOrganizationUsersSort();
  const {
    status: { fetchUsers: status },
  } = useOrganization();
  const sort = useOrganizationUsersSort();

  return (
    <Sort baseTranslationKey="organization.users.table" by={by} sort={sort} status={status} updateSort={updateSort} />
  );
};
